<template>
  <b-img :src="'/img/' + getIcon(filename)" :alt="filename" :scale="'scale-' + scale" />
</template>


<script>
export default {
  props: {
    filename: {
      type: String,
      default: ''
    },
    scale: {
      type: String,
      default: 'large'
    }
  },
  data: function() {
    return {
      knownExtensions: {
        accdb: 'accdb',
        avi: 'avi',
        bmp: 'bmp',
        css: 'css',
        doc: 'docx_win',
        docx: 'docx_win',
        eml: 'eml',
        eps: 'eps',
        fla: 'fla',
        gif: 'gif',
        htm: 'html',
        html: 'html',
        ind: 'ind',
        jpg: 'jpeg',
        jpeg: 'jpeg',
        jsf: 'jsf',
        midi: 'midi',
        mov: 'mov',
        mp3: 'mp3',
        mpeg: 'mpeg',
        mpg: 'mpeg',
        pdf: 'pdf',
        png: 'png',
        ppt: 'pptx_win',
        pptx: 'pptx_win',
        proj: 'proj',
        project: 'proj',
        psd: 'psd',
        pst: 'pst',
        pub: 'pub',
        rar: 'rar',
        readme: 'readme',
        settings: 'settings',
        setting: 'settings',
        text: 'text',
        txt: 'text',
        tif: 'tiff',
        tiff: 'tiff',
        url: 'url',
        vsd: 'vsd',
        wav: 'wav',
        wave: 'wav',
        wma: 'wma',
        wmv: 'wmv',
        xlsx: 'xlsx_win',
        xls: 'xlsx_win',
        zip: 'zip'
      }
    }
  },
  methods: {
    getIcon(filename) {
      const prefix = 'file-icons/'
      let postfix = '-48_32.png'
      if (this.scale === 'large') {
        postfix = '-256_32.png'
      }

      if (filename) {
        let extension = ''
        if (filename.lastIndexOf('.') >= 0) {
          extension = filename.substring(filename.lastIndexOf('.') + 1)
        }

        if (extension) {
          if (this.knownExtensions[extension.toLowerCase()]) {
            return (
              prefix + this.knownExtensions[extension.toLowerCase()] + postfix
            )
          }
        }
      }
      return prefix + 'unknown' + postfix
    }
  }
}
</script>

<style scoped>
[scale='scale-extra-small'] {
  width: 16px;
}
</style>
